/**
 * Create copy from reference type data.
 * @param data reference type data.
 * @returns copy of the data.
 */
export function refCopy<T>(data:T): T {
    return JSON.parse(JSON.stringify(data));
}